import type { SearchByNameResponse, SearchResponse } from "@domain/Search";
import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";
import { env } from "../../config/env";

/** The admin search: `GET /search`, served from the API's in-memory index. */
export class SearchAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/search`;
	}

	/** Opts out of the app-wide error toast: the box says a failed search in its own dropdown. */
	public async search(query: string, limit: number): Promise<SearchResponse> {
		const response = await apiClient.get<SearchResponse>(this.baseUrl, {
			...StandardAxiosConfig(10),
			params: { q: query, limit },
			suppressErrorToast: true,
		});
		return response.data;
	}

	/** Opts out of the toast too: a failure here only sends the box to the jobs filter. */
	public async byName(name: string): Promise<SearchByNameResponse> {
		const response = await apiClient.get<SearchByNameResponse>(`${this.baseUrl}/by-name`, {
			...StandardAxiosConfig(10),
			params: { name },
			suppressErrorToast: true,
		});
		return response.data;
	}
}
